import { useIsLoggedIn } from "../../components";
import { UiLoginContainerModel } from "../../models";
import { renderViewModel } from "../../render-view-model";

export type UiLoginContainerProps = {
    model: UiLoginContainerModel;
};

const UiLoginContainer = ({ model }: UiLoginContainerProps) => {
    const loggedIn = useIsLoggedIn();
    const { defaultContent, loggedInContent } = model.content;

    if (loggedIn === true && loggedInContent) {
        return (
            <>
                {loggedInContent.map((uiComponent) =>
                    renderViewModel(uiComponent)
                )}
            </>
        );
    } else if (loggedIn === false && defaultContent) {
        return (
            <>
                {defaultContent.map((uiComponent) =>
                    renderViewModel(uiComponent)
                )}
            </>
        );
    } else {
        return null;
    }
};

export default UiLoginContainer;
